import { DiscountFactory } from '../factories/discount-factory.js';
import { Discount } from '../models/serializable/discounts/discount.js';
import { FlexiblePassProtocol } from '../models/serializable/open-access-pass/flexible-pass-protocol.js';
import { OpenAccessPassDetails } from '../models/serializable/open-access-pass/open-access-pass-details.js';
import { Price } from '../models/serializable/price.js';
import { DiscountModifier, DiscountProvider } from './discount-provider.js';

export class FlexiblePassDiscountProvider extends DiscountProvider {
  private uses: number;
  private readonly protocol: FlexiblePassProtocol;

  constructor(private readonly pass: OpenAccessPassDetails) {
    super();

    if(!FlexiblePassProtocol.assertType(pass.protocol)) {
      throw new Error(`Expected {${FlexiblePassProtocol.TYPE_ID}}, got: ${pass.protocol.$typeId}`);
    }

    this.protocol = pass.protocol;
    this.uses = this.protocol.uses ?? 0;
  }

  findDiscountForMultipleTickets(_ticketId: string, quantity: number): DiscountModifier | null {
    if(quantity <= 0) {
      return null;
    }

    const availableUses = this.getAvailableUses(quantity);
    if(availableUses <= 0) {
      return null;
    }

    this.uses += availableUses;
    return {
      discount: DiscountFactory.fromFlexiblePass(this.pass),
      availableUses,
    };
  }

  findDiscountForSingleTicket(_ticketId: string): Discount | null {
    if(this.getAvailableUses(1) <= 0) {
      return null;
    }

    this.uses++;
    return DiscountFactory.fromFlexiblePass(this.pass);
  }

  findDiscountForOrder(_orderPrice: Price): Discount | null {
    return null;
  }

  reset(): void {
    this.uses = this.protocol.uses ?? 0;
  }

  private getAvailableUses(quantity: number): number {
    const maximumUses = this.protocol.maxUses;
    if(maximumUses.isInfinite) {
      return quantity;
    }

    return Math.min(quantity, Math.max(0, maximumUses.value - this.uses));
  }
}
